import Calendario from "../../ComponentesGlobales/Calendario";
import ListaDesplegable from "../../ComponentesGlobales/ListaDesplegable";
import BuscadorMercaderias from "../../ComponentesGlobales/BuscadorMercaderias";
import { useStoreEntrada } from "./useStoreEntradas";
import qr from "../../icons/qr.png";
import { useState, useMemo, useEffect } from "react";
import { useStoreHome } from "../Home/useStoreHome";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";
import { MensajeInfo, MensajeToastError, MensajeToastAdvertencia } from "../../componentes/FuncionesLocales";
import ScannerUnico from "../../ComponentesGlobales/ScannerUnico";

export default function EntradasTab1() {
    const Unidades = useStoreEntrada((state) => state.Unidades);
    const Kilos = useStoreEntrada((state) => state.Kilos);
    const Proceso = useStoreEntrada((state) => state.Proceso);
    const ListaProcesos = useStoreEntrada((state) => state.ListaProcesos);
    const BuscandoProcesos = useStoreEntrada((state) => state.BuscandoProcesos);
    const ListaMercaderias = useStoreEntrada((state) => state.ListaMercaderias);
    const Mercaderia = useStoreEntrada((state) => state.Mercaderia);
    const Fecha = useStoreEntrada((state) => state.Fecha);
    const Procesando = useStoreEntrada((state) => state.Procesando);
    const BuscandoCodbar = useStoreEntrada((state) => state.BuscandoCodbar);
    const CodbarLeido = useStoreEntrada((state) => state.CodbarLeido);
    const deviceConsentimiento = useStoreHome((state) => state.deviceConsentimiento);
    const [showQRScanner, setShowQRScanner] = useState(false);
    const MercaderiaUnidad = useStoreEntrada((state) => state.MercaderiaUnidad);
    const FechasConEntradas = useStoreEntrada((s) => s.FechasConEntradas);
    const Lote = useStoreEntrada((s) => s.Lote);

    useEffect(() => {
        useStoreEntrada.getState().getFechas();
    }, []);


    useEffect(() => {
        if (Mercaderia && Mercaderia.Id) {
            useStoreEntrada.getState().getMercaderiaUnidad();
        }
    }, [Mercaderia]);



    // Guardar los datos
    const Guardar = () => {

        if (!Proceso || String(Proceso) === "") {
            MensajeInfo("Debe seleccionar un proceso.");
            return;
        }
        if (!Mercaderia || !Mercaderia.Id || Mercaderia.Id === 0) {
            MensajeInfo("Debe seleccionar una mercadería.");
            return;
        }
        if (Number(Unidades) <= 0 || Number(Kilos) <= 0) {
            MensajeInfo("La cantidad y el peso deben ser mayores a 0.");
            return;
        }
        useStoreEntrada.getState().insertEntrada();
    }




    // Manejar el escaneo del QR
    const [Entrolectura, setEntroLectura] = useState(false);
    const [lastQrValue, setLastQrValue] = useState(''); // Para evitar lecturas duplicadas del mismo código

    const handleQRScan = (result) => {
        // Verificaciones para evitar doble escaneo
        if (Entrolectura) {
            console.log('🚫 Escaneo bloqueado: procesando lectura anterior');
            return;
        }

        // Evitar el mismo código QR en un corto período de tiempo
        if (lastQrValue === result) {
            console.log('🚫 Escaneo bloqueado: mismo código QR reciente');
            return;
        }

        setEntroLectura(true);
        setLastQrValue(result);

        try {
            useStoreEntrada.setState({ CodbarLeido: { sCodbar: result } });
            setShowQRScanner(false);

            useStoreEntrada.getState().getCodbar(result)


        } catch (error) {
            console.error('Error al procesar el QR escaneado:', error);
            MensajeToastError('Ocurrió un error al procesar el código QR.', 4000);
        } finally {
            // Permitir nuevo escaneo después de un retraso más largo
            setTimeout(() => {
                setEntroLectura(false);
                // console.log('✅ Listo para nuevo escaneo');
            }, 1500);

            // Limpiar el último QR después de un tiempo para permitir re-escaneo del mismo código
            setTimeout(() => {
                setLastQrValue('');
                // console.log('🔄 Cache de QR limpiado');
            }, 5000);
        }
    };


    const openQRScanner = () => {
        if (deviceConsentimiento !== "granted") {
            MensajeToastAdvertencia("Habilitá permisos en el Home para usar la cámara.", 3000);
            return;
        }
        if (!window.isSecureContext) {
            MensajeToastAdvertencia("La cámara funciona solo en https o localhost (no en 192.168.x.x http).", 4000);
            return;
        }
        if (!navigator.mediaDevices?.getUserMedia) {
            MensajeToastError("Tu navegador no soporta acceso a cámara.", 3000);
            return;
        }
        setShowQRScanner(true);
    };


    const closeQRScanner = () => {
        console.log('🚪 Cerrando QR Scanner desde EntradasTab1...');
        setShowQRScanner(false);

        // Limpieza adicional de seguridad para cualquier video elemento que pueda quedar
        setTimeout(() => {
            try {
                const videos = Array.from(document.querySelectorAll("video"));
                // console.log(`🧹 Limpieza de seguridad: encontrados ${videos.length} elementos video`);

                videos.forEach((video) => {
                    const stream = video.srcObject;
                    if (stream?.getTracks) {
                        const tracks = stream.getTracks();
                        tracks.forEach(track => {
                            if (track.readyState === 'live') {
                                track.stop();
                                //console.log(`🔴 Track ${index}-${track.kind} detenido en limpieza de seguridad`);
                            }
                        });
                    }
                    // Limpiar el video element
                    video.srcObject = null;
                    video.src = '';
                });

                // console.log('✅ Limpieza de seguridad completada');
            } catch (error) {
                console.warn("No se pudo completar la limpieza de la cámara:", error);
            }
        }, 100); // Pequeño delay para asegurar que el componente se desmonte primero
    };

    const mercaderiaSel = useMemo(
        () => ListaMercaderias?.find(x => x.Id === Mercaderia?.Id),
        [ListaMercaderias, Mercaderia]
    );

    const stockKg = Mercaderia?.sExtra ?? mercaderiaSel?.sExtra ?? 0;

    //console.log(ListaMercaderias);

    return (
        <>
            <div className="prod-bloque-form">

                <div className="bloque-cabecera">
                    <h4 className="prod-subtitulo">Materia Prima / Insumo</h4>

                    <div className="btns">
                        <button title="Limpiar campos" className="btn-limpiar" onClick={useStoreEntrada.getState().limpiezaTotal}>
                            <i className="pi pi-eraser" aria-hidden="true" /><span>Limpiar</span>
                        </button>
                    </div>

                </div>

                <div className="prod-campo">
                    <div className="camp-o">
                        <span className="mensaje-obligatorio">*</span>
                        <label htmlFor="procesoNombre">Proceso Productivo:</label>
                    </div>

                    <ListaDesplegable Lista={ListaProcesos} Buscando={BuscandoProcesos}
                        setValor={(e) => useStoreEntrada.setState({ Proceso: e })}
                        Seleccionado={Proceso} TituloNoSeleccionado={"Nuevo Proceso"} />

                </div>

                <BlockUI blocked={BuscandoCodbar}
                    template={<ProgressSpinner style={{ width: '24px', height: '24px', color: "white" }} strokeWidth="8" animationDuration="5.15s" />} >

                    <div className="desp-campo-qr entradas">
                        <input
                            type="text"
                            readOnly={true}
                            placeholder={CodbarLeido?.sCodbar || "Escanear QR"}
                            value={CodbarLeido ? CodbarLeido.sCodbar : ""}
                            className="input-qr"
                        />
                        <img
                            src={qr}
                            alt="qr"
                            className="qr clickable"
                            onClick={deviceConsentimiento === "granted" ? openQRScanner : undefined}
                            title={deviceConsentimiento === "granted" ? "Abrir escáner QR" : "Necesita permiso en Home"}
                            style={{ cursor: deviceConsentimiento === "granted" ? "pointer" : "not-allowed", opacity: deviceConsentimiento === "granted" ? 1 : 0.4 }}
                        />
                    </div>
                    {CodbarLeido?.sCodbar && <h5 style={{ marginBottom: '8px', color: 'red', fontSize: '10px', alignSelf: 'center', width: '100%' }}>Se ingresara este codigo Id: {CodbarLeido.IndentificadorId}</h5>}
                </BlockUI>

                <div className="prod-fila-flex">

                    <div className="prod-campo">
                        <div className="camp-o">
                            <span className="mensaje-obligatorio">*</span>
                            <label htmlFor="productoNombre">
                                Materia Prima / Insumo:
                            </label>
                        </div>

                        <BuscadorMercaderias
                            Buscar={useStoreEntrada.getState().getMercaderia}
                            LimpiarResultados={useStoreEntrada.getState().limpiarResultadosMercaderias}
                            setValor={(e) => useStoreEntrada.setState({ Mercaderia: e })}
                            Seleccionado={Mercaderia} TituloNoSeleccionado={"Debe seleccionar una mercadería"} required />

                    </div>

                    <div className="prod-campo">
                        <div className="camp-o">
                            <span className="mensaje-obligatorio">*</span>
                            <label>Fecha de producción:</label>
                        </div>
                        <Calendario
                            Fecha={Fecha}
                            setFecha={(fecha) => useStoreEntrada.setState({ Fecha: fecha })}
                            highlightedDates={FechasConEntradas}
                        />
                    </div>


                    <div>
                        <div className="ing-campo">
                            <label htmlFor="lote" >Lote de fabricación:</label>
                        </div>
                        <input
                            type="text"
                            name="lote"
                            placeholder="0000"
                            value={Lote}
                            onChange={(e) => useStoreEntrada.setState({ Lote: e.target.value })}
                            autoComplete="off"
                        />
                    </div>


                    <div className="prod-camposUK">


                        <div className="prod-campo">
                            <div className="camp-o">

                                <span className="mensaje-obligatorio">*</span>
                                <div style={{ display: 'flex', justifyContent: 'space-between' , width: '100%'}}>
                                    <label>{MercaderiaUnidad?.sDescripcion || "Medida"}</label>
                                    <label style={{marginRight: '8px'}}>Stock: {Number(stockKg)}</label>
                                </div>
                            </div>
                            <input
                                type="number"
                                name="kilos"
                                value={Kilos}
                                onChange={(e) => useStoreEntrada.setState({ Kilos: e.target.value })}
                                placeholder="0000"
                            />
                        </div>


                    </div>

                    <span className="mensaje-obligatorio" style={{ marginBottom: '8px' }}>* Campo obligatorio</span>

                </div>





                <BlockUI blocked={Procesando}
                    template={<ProgressSpinner style={{ width: '24px', height: '24px', color: "white" }} strokeWidth="8" animationDuration="5.15s" />} >
                    <div className="prod-cta" style={{ display: "flex", justifyContent: "center", }}>
                        <button onClick={Guardar} type="submit" style={{ backgroundColor: 'var(--app-brand)', color: 'white', width: '100%', fontSize: '1rem', padding: '12px 16px', borderRadius: '12px' }}>Agregar</button>
                    </div>
                </BlockUI>
            </div>

             {showQRScanner && (
            <ScannerUnico
                isActive={showQRScanner && !Entrolectura}
                onScan={!Entrolectura ? handleQRScan : null}
                onClose={closeQRScanner}
            />
            )} 
        </>
    );
};
